export const createStylesheet = (href: string): HTMLLinkElement => {
  const stylesheet = document.createElement('link');
  stylesheet.type = 'text/css';
  stylesheet.rel = 'stylesheet';
  stylesheet.href = href;
  return stylesheet;
};
